export const INCREMENT_STEP = 'INCREMENT_STEP';
export const DECREMENT_STEP = 'DECREMENT_STEP';
export const APRON_DEACTIVATE = 'APRON_DEACTIVATE';
export const TILE_FALNGES_DEACTIVATE = 'TILE_FALNGES_DEACTIVATE';

export const CHANGE_DWDF = 'CHANGE_DWDF';
export const CHANGE_WT = 'CHANGE_WT';
export const CHANGE_BATHTUB = 'CHANGE_BATHTUB';
export const CHANGE_KRW = 'CHANGE_BATHTUB';
export const CHANGE_DATA = 'CHANGE_DATA';

export const CHANGE_IMAGE = 'CHANGE_IMAGE';

// breadcrumbs
export const SET_BREADCRUMBS = 'SET_BREADCRUMbs';
export const GET_BREADCRUMBS = 'GET_BREADCRUMbs';

// data
export const FETCH_DATA = 'FETCH_DATA';
export const FETCH_BATHTUB_DATA_ERROR = 'FETCH_BATHTUB_DATA_ERROR';
export const FETCH_BATHTUB_DATA_SUCCESS = 'FETCH_BATHTUB_DATA_SUCCESS';
export const FETCH_DWDF_DATA_ERROR = 'FETCH_DWDF_DATA_ERROR';
export const FETCH_URINAL_DATA_ERROR = 'FETCH_WT_DATA_ERROR';
export const FETCH_WT_DATA_ERROR = 'FETCH_URINAL_DATA_ERROR';
export const FETCH_DWDF_DATA_SUCCESS = 'FETCH_DWDF_DATA_SUCCESS';
export const FETCH_WT_DATA_SUCCESS = 'FETCH_WT_DATA_SUCCESS';
export const FETCH_URINAL_DATA_SUCCESS = 'FETCH_URINAL_DATA_SUCCESS';
export const FETCH_KRW_DATA_SUCCESS = 'FETCH_URINAL_DATA_SUCCESS';
export const FETCH_KRW_DATA_ERROR = 'FETCH_URINAL_DATA_SUCCESS';

// image
export const FETCH_IMAGE = 'FETCH_IMAGE';
export const FETCH_IMAGE_SUCCESS = 'FETCH_IMAGE_SUCCESS';
export const FETCH_IMAGE_ERROR = 'FETCH_IMAGE_ERROR';

// loading
export const LOADING_ERROR = 'LOADING_ERROR';
export const LOADING_SUCCESS = 'LOADING_SUCCESS';

// article
export const FETCH_ARTICLE = 'FETCH_ARTICLE';

// add to summary
export const SET_SUMMARY = 'SET_SUMMARY';

// check form validation
export const IS_FORM_VALID = 'IS_FORM_VALID';

// toggle price display
export const TOGGLE_PRICES = 'TOGGLE_PRICES';


// WEBPACK FOOTER //
// ./src/actions/types.js